import styled from 'styled-components';

export const Hero = styled.div`
  border-radius: 8px;
  background-color: #ffffff;
  margin: 30px;
  padding: 30px;
`;
